import { render, staticRenderFns } from "./DateTimeResult.vue?vue&type=template&id=122e226a"
import script from "./DateTimeResult.vue?vue&type=script&lang=js"
export * from "./DateTimeResult.vue?vue&type=script&lang=js"
import style0 from "./DateTimeResult.vue?vue&type=style&index=0&id=122e226a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports